// removed by extract-text-webpack-plugin
module.exports = {"container":"_1cPAyiTiHqtG1khFRApJLb","Email":"_3zWK9yZa0Q4-hrSpsx0T8A","Signer":"_3glNBbwrwbLq71I3kAZ4Gf","Icon":"yh3_kius6UncSHQbDF4Kv","Title":"_3ziy48PJTNtq5tO1PPF7Ba"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/PubDocumentVerify/DocVerifier/Verify/BioSigners/styles.css
// module id = 3027
// module chunks = 0